/* Quotrell Size Quiz — self-contained PDP widget. v3 (universeel profiel + auto "Your size is X" pill) */
(function(){
"use strict";
if(window.__QSQ_LOADED)return; window.__QSQ_LOADED=true;
var P=window.QSQ_PRODUCT||{type:'',handle:'',image:''};
var CDN='https://cdn.shopify.com/s/files/1/0284/7355/7064/files/';
var IMG={torso:CDN+'man-torso.webp?v=1783597706',logo:CDN+'Quotrell_logo_black.png?v=1729054858'};
/* Per geslacht en per boven/onderlichaam een passend lichaam. Bij broeken tonen we het
   onderlichaam zodat de beenlengte zichtbaar is; daar zit de taille bovenin het beeld. */
var BODY={
  top:{ women:{src:CDN+'dames-torso-tops.webp?v=1786803648', zone:34},
        men:{src:CDN+'man-torso.webp?v=1783597706', zone:34} },
  bottom:{ women:{src:CDN+'dames-onderlichaam-broeken.webp?v=1786803648', zone:10},
           men:{src:CDN+'heren-onderlichaam-broeken.webp?v=1786803648', zone:12} }
};
function bodyBeeld(g){
  try{
    var groep=(g==='bottom')?'bottom':'top';
    var gd=(P.gender||'').toLowerCase();
    var set=BODY[groep];
    return (gd==='women')?set.women:set.men;   /* unisex volgt de herensnit */
  }catch(e){ return {src:IMG.torso, zone:g==='bottom'?60:34}; }
}
/* lichaamsvorm-foto's bij de Build- en Waist-vraag — heren + dames, gekozen o.b.v. product-gender */
var MSHAPE={
  frame:{slim:CDN+'male_chestShape_Narrower_baa39d9e-325e-4de2-917b-91ee3f828660.webp',average:CDN+'male_chestShape_Average_4e7270ce-d465-4178-8bb4-0d4b72d3e1d9.webp',broad:CDN+'male_chestShape_Broader_c4b690ac-b0cf-406a-8f6b-66ebe10d8af6.webp'},
  waist:{slim:CDN+'male_bellyShape_Flatter_ead11763-0e8e-4993-a002-ee73a5e1b569.webp',average:CDN+'male_bellyShape_Average_80646d82-eb0f-474f-bb23-472c1c834095.webp',full:CDN+'male_bellyShape_Rounder_1f5d8601-48da-4c66-9541-8fbcabbf33de.webp'}
};
var WSHAPE={
  frame:{slim:CDN+'female_chestShape_Narrower.png',average:CDN+'female_chestShape_Average.png',broad:CDN+'female_chestShape_Broader.png'},
  waist:{slim:CDN+'female_bellyShape_Flatter.png',average:CDN+'female_bellyShape_Average.png',full:CDN+'female_bellyShape_Rounder.png'}
};
function shapeMap(){return (P.gender||'').toLowerCase()==='women'?WSHAPE:MSHAPE;}

/* ---------- i18n (Shopify Markets · EN/DE/ES/FR, val terug op EN) ---------- */
var I18N={
 en:{whatsize:"What is my size?",yoursize:"Your size is",tip_h:"Your personal size recommendation",tip_p:"This recommendation is based on the details you provided earlier. We use your body measurements to calculate the most accurate fit for this specific product.",find_h:"Find your perfect size",find_sub:"In under 30 seconds.",height:"Height",weight:"Weight",build:"Build",waist:"Waist",fit:"Preferred fit",slim:"Slim",average:"Average",broad:"Broad",fuller:"Fuller",fitted:"Fitted",regular:"Regular",relaxed:"Relaxed",find_cta:"Find my size",loading_h:"Finding your size",loading_sub:"Just a moment.",rec_label:"Recommended size",conf_high:"High confidence",conf_between:"Between sizes",edit:"Edit my measurements",add_cta:"Add size {size} to cart",view_chart:"View full size chart",tab_chart:"Size chart",tab_htm:"How to measure",chart_note:"Measurements in cm, taken flat on the garment.",fit_sentence:"Size <b>{size}</b> fits {q} around your {zone}.",fit_just:"just right",fit_snug:"a bit snug",fit_roomy:"a bit roomy",zone_chest:"chest",zone_waist:"waist",note_suggest:"Between {a} and {b} — we suggest {b} for a comfortable fit.",note_between:"Between {a} and {b}.",m_chest_t:"Chest",m_chest_d:"Measure flat from armpit to armpit across the chest.",m_length_t:"Length",m_length_d:"Measure from the shoulder straight down to the hem.",m_sleeve_t:"Sleeve",m_sleeve_d:"Measure from the shoulder seam to the end of the sleeve.",m_waist_t:"Waist",m_waist_d:"Measure flat along the waistband, seam to seam.",m_crotch_t:"Crotch",m_crotch_d:"Measure from the top of the waistband to the crotch seam.",m_outside_t:"Outside length",m_outside_d:"Measure from the top of the waistband to the bottom of the leg."},
 de:{whatsize:"Was ist meine Größe?",yoursize:"Deine Größe ist",tip_h:"Deine persönliche Größenempfehlung",tip_p:"Diese Empfehlung basiert auf den zuvor angegebenen Daten. Wir nutzen deine Körpermaße, um die genaueste Passform für dieses Produkt zu berechnen.",find_h:"Finde deine perfekte Größe",find_sub:"In unter 30 Sekunden.",height:"Körpergröße",weight:"Gewicht",build:"Statur",waist:"Taille",fit:"Bevorzugte Passform",slim:"Schmal",average:"Normal",broad:"Breit",fuller:"Fülliger",fitted:"Eng",regular:"Regulär",relaxed:"Locker",find_cta:"Meine Größe finden",loading_h:"Deine Größe wird ermittelt",loading_sub:"Einen Moment.",rec_label:"Empfohlene Größe",conf_high:"Hohe Sicherheit",conf_between:"Zwischen Größen",edit:"Meine Maße ändern",add_cta:"Größe {size} in den Warenkorb",view_chart:"Vollständige Größentabelle",tab_chart:"Größentabelle",tab_htm:"So misst du",chart_note:"Maße in cm, flach am Kleidungsstück gemessen.",fit_sentence:"Größe <b>{size}</b> sitzt {q} an deiner {zone}.",fit_just:"genau richtig",fit_snug:"etwas enger",fit_roomy:"etwas lockerer",zone_chest:"Brust",zone_waist:"Taille",note_suggest:"Zwischen {a} und {b} — wir empfehlen {b} für einen bequemen Sitz.",note_between:"Zwischen {a} und {b}.",m_chest_t:"Brust",m_chest_d:"Flach von Achsel zu Achsel über die Brust messen.",m_length_t:"Länge",m_length_d:"Von der Schulter gerade nach unten bis zum Saum messen.",m_sleeve_t:"Ärmel",m_sleeve_d:"Von der Schulternaht bis zum Ärmelende messen.",m_waist_t:"Bund",m_waist_d:"Flach entlang des Bundes messen, Naht zu Naht.",m_crotch_t:"Schritt",m_crotch_d:"Vom oberen Bund bis zur Schrittnaht messen.",m_outside_t:"Außenlänge",m_outside_d:"Vom oberen Bund bis zum Beinabschluss messen."},
 es:{whatsize:"¿Cuál es mi talla?",yoursize:"Tu talla es",tip_h:"Tu recomendación de talla personal",tip_p:"Esta recomendación se basa en los datos que indicaste antes. Usamos tus medidas corporales para calcular el ajuste más preciso para este producto.",find_h:"Encuentra tu talla perfecta",find_sub:"En menos de 30 segundos.",height:"Altura",weight:"Peso",build:"Complexión",waist:"Cintura",fit:"Ajuste preferido",slim:"Estrecho",average:"Medio",broad:"Ancho",fuller:"Más lleno",fitted:"Ajustado",regular:"Normal",relaxed:"Holgado",find_cta:"Encontrar mi talla",loading_h:"Buscando tu talla",loading_sub:"Un momento.",rec_label:"Talla recomendada",conf_high:"Alta confianza",conf_between:"Entre tallas",edit:"Editar mis medidas",add_cta:"Añadir talla {size} al carrito",view_chart:"Ver tabla de tallas completa",tab_chart:"Tabla de tallas",tab_htm:"Cómo medir",chart_note:"Medidas en cm, tomadas en plano sobre la prenda.",fit_sentence:"La talla <b>{size}</b> queda {q} en tu {zone}.",fit_just:"perfecta",fit_snug:"un poco ajustada",fit_roomy:"un poco holgada",zone_chest:"pecho",zone_waist:"cintura",note_suggest:"Entre {a} y {b} — recomendamos {b} para un ajuste cómodo.",note_between:"Entre {a} y {b}.",m_chest_t:"Pecho",m_chest_d:"Mide en plano de axila a axila a la altura del pecho.",m_length_t:"Largo",m_length_d:"Mide desde el hombro recto hacia abajo hasta el bajo.",m_sleeve_t:"Manga",m_sleeve_d:"Mide desde la costura del hombro hasta el final de la manga.",m_waist_t:"Cintura",m_waist_d:"Mide en plano a lo largo de la cinturilla, de costura a costura.",m_crotch_t:"Tiro",m_crotch_d:"Mide desde la parte superior de la cinturilla hasta la costura de la entrepierna.",m_outside_t:"Largo exterior",m_outside_d:"Mide desde la parte superior de la cinturilla hasta el bajo de la pierna."},
 fr:{whatsize:"Quelle est ma taille ?",yoursize:"Ta taille est",tip_h:"Ta recommandation de taille personnalisée",tip_p:"Cette recommandation est basée sur les informations que tu as fournies. Nous utilisons tes mensurations pour calculer la coupe la plus précise pour ce produit.",find_h:"Trouve ta taille parfaite",find_sub:"En moins de 30 secondes.",height:"Taille",weight:"Poids",build:"Carrure",waist:"Tour de taille",fit:"Coupe préférée",slim:"Mince",average:"Moyen",broad:"Large",fuller:"Plus fort",fitted:"Près du corps",regular:"Classique",relaxed:"Ample",find_cta:"Trouver ma taille",loading_h:"Recherche de ta taille",loading_sub:"Un instant.",rec_label:"Taille recommandée",conf_high:"Grande confiance",conf_between:"Entre deux tailles",edit:"Modifier mes mensurations",add_cta:"Ajouter la taille {size} au panier",view_chart:"Voir le guide des tailles",tab_chart:"Guide des tailles",tab_htm:"Comment mesurer",chart_note:"Mesures en cm, prises à plat sur le vêtement.",fit_sentence:"La taille <b>{size}</b> est {q} au niveau de ta {zone}.",fit_just:"parfaite",fit_snug:"un peu ajustée",fit_roomy:"un peu ample",zone_chest:"poitrine",zone_waist:"taille",note_suggest:"Entre {a} et {b} — nous conseillons {b} pour un ajustement confortable.",note_between:"Entre {a} et {b}.",m_chest_t:"Poitrine",m_chest_d:"Mesure à plat d'une aisselle à l'autre au niveau de la poitrine.",m_length_t:"Longueur",m_length_d:"Mesure de l'épaule jusqu'en bas, jusqu'à l'ourlet.",m_sleeve_t:"Manche",m_sleeve_d:"Mesure de la couture d'épaule jusqu'au bout de la manche.",m_waist_t:"Taille",m_waist_d:"Mesure à plat le long de la ceinture, d'une couture à l'autre.",m_crotch_t:"Entrejambe",m_crotch_d:"Mesure du haut de la ceinture jusqu'à la couture de l'entrejambe.",m_outside_t:"Longueur extérieure",m_outside_d:"Mesure du haut de la ceinture jusqu'au bas de la jambe."}
};
var LANG=((window.Shopify&&Shopify.locale)||document.documentElement.lang||P.lang||'en').slice(0,2).toLowerCase();
if(!I18N[LANG])LANG='en';
function T(k){var d=I18N[LANG];var v=(d&&d[k]!=null)?d[k]:I18N.en[k];return v==null?k:v;}

/* ---------- analytics (anoniem, fire-and-forget) ---------- */
var TRACK_URL='https://quotrell-dashboard.vercel.app/api/size-quiz-track';
function track(ev,extra){
  try{
    var g='top';try{g=chart().g;}catch(e){}
    var body={event:ev,handle:P.handle||'',type:P.type||'',group:g,gender:(P.gender||'').toLowerCase(),lang:LANG};
    if(extra)for(var k in extra)body[k]=extra[k];
    var s=JSON.stringify(body);
    /* text/plain = CORS-safelisted → geen preflight → sendBeacon werkt cross-origin (server parset 't toch als JSON) */
    if(navigator.sendBeacon){navigator.sendBeacon(TRACK_URL,new Blob([s],{type:'text/plain'}));}
    else{fetch(TRACK_URL,{method:'POST',headers:{'Content-Type':'text/plain'},body:s,keepalive:true}).catch(function(){});}
  }catch(e){}
}

/* ---------- ECHTE Quotrell size charts (garment-maten in cm, uit Shopify) ---------- */
var BOTTOM_TYPES=['PANTS','JEANS','SHORTS','SWIMSHORTS'];
var FALLBACK={
  bottom:{g:'bottom',pi:0,cols:['Waist','Crotch','Length'],rows:{S:[38.5,30,109],M:[40,31,110],L:[41.5,32,111],XL:[43,33,112],XXL:[44.5,34,113]}},
  top:{g:'top',pi:0,cols:['Chest','Length','Sleeve'],rows:{S:[62,66,56],M:[64,68,58],L:[66,70,60],XL:[68,72,62],XXL:[70,74,64]}}
};
function chart(){
  var q2=window.QSQ_CHARTS;
  if(q2&&q2.byHandle&&P.handle&&q2.byHandle[P.handle]!=null){var c=q2.list[q2.byHandle[P.handle]];if(c)return c;}
  var fb=BOTTOM_TYPES.indexOf((P.type||'').toUpperCase())>=0?FALLBACK.bottom:FALLBACK.top;
  fb._fallback=true; return fb;
}
var SIZES=null;

/* ---------- ankermerk-vertaaltabel (lichaams-borst-cm die in dat merk-label past, heren) ----------
   Sterkste correctie: veel Quotrell-klanten shoppen bij Zara/COS. Tunebaar met echte data.
   Ankermerk overrulet de borst-schatting (tops). Bij broeken telt het lichaam. */
var ANCHOR={
  'Zara':{XS:86,S:92,M:99,L:107,XL:115,XXL:123},
  'H&M':{XS:86,S:92,M:99,L:107,XL:115,XXL:123},
  'COS':{XS:88,S:94,M:101,L:109,XL:117,XXL:125},
  'Uniqlo':{XS:84,S:90,M:97,L:105,XL:113,XXL:121},
  'Ralph Lauren':{XS:90,S:96,M:103,L:111,XL:119,XXL:127},
  'Nike':{XS:86,S:92,M:99,L:107,XL:115,XXL:123}
};
var ANCHOR_BRANDS=['Zara','COS','H&M','Uniqlo','Ralph Lauren','Nike'];

/* ---------- state + profiel (localStorage) ---------- */
var KEY='quotrell_fit_v1';
function load(){try{return JSON.parse(localStorage.getItem(KEY)||'null');}catch(e){return null;}}
function save(p){try{localStorage.setItem(KEY,JSON.stringify(p));}catch(e){}}
function forget(){try{localStorage.removeItem(KEY);}catch(e){}}
var q={step:0,unit:'cm',h:180,w:80,frame:'average',waist:'average',fit:'regular',anchor:{brand:'',size:''},est:null,chosen:null};
function profileObj(){return {h:q.h,w:q.w,frame:q.frame,waist:q.waist,fit:q.fit,unit:q.unit,anchor:q.anchor};}

/* ---------- helpers ---------- */
function n1(v){return Math.round(v*10)/10;}
function disp(v){return q.unit==='cm'?v:n1(v/2.54);}
function U(){return q.unit==='cm'?'cm':'in';}
/* Gewicht boven deze grens telt minder zwaar mee voor de borstomvang.
   Reden: de formule was recht toe recht aan 0,60 per kilo, dus elke 13 kg
   een maat groter. Bij zwaardere mensen zit dat gewicht grotendeels op
   taille en benen en niet op de borst, waardoor het advies doorschoot.
   Dat kwam ook terug in de retouren van september: te groot tegen te klein
   stond op 0,94 bij XS en 1,5 bij S/M/L, maar op 2,84 bij XL en 3,17 bij XXL.
   Zet DEMPING_VANAF op 999 om dit uit te zetten en de oude formule terug te
   krijgen; de rest van de berekening verandert dan niets. */
var DEMPING_VANAF = 80;   /* kg */
var DEMPING_FACTOR = 0.32; /* per kilo daarboven, in plaats van 0.60 */

function estimate(){
  var h=q.h,w=q.w;
  var fb={slim:-4,average:0,broad:5}[q.frame]||0;
  var wb={slim:-3,average:0,full:6}[q.waist]||0;
  var wBasis=Math.min(w,DEMPING_VANAF), wExtra=Math.max(0,w-DEMPING_VANAF);
  var chest=n1(0.60*wBasis+DEMPING_FACTOR*wExtra+0.36*h-6+fb);
  if(q.anchor&&q.anchor.brand&&q.anchor.size&&ANCHOR[q.anchor.brand]&&ANCHOR[q.anchor.brand][q.anchor.size]!=null){
    chest=ANCHOR[q.anchor.brand][q.anchor.size]; /* ankermerk overrulet borst */
  }
  return {chest:chest,waist:n1(0.75*w+0.16*h-3+wb),hip:n1(0.55*w+0.22*h+8+wb*0.5)};
}
function sizeList(){return SIZES&&SIZES.length?SIZES:Object.keys(chart().rows);}
function modelNote(){return P.model?('<div class="qsq-model"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 9h18v6H3z"/><path d="M7 9v3M11 9v4M15 9v3M19 9v4"/></svg><span>'+P.model+'</span></div>'):'';}

var SIZE_ORDER=['XS','S','M','L','XL','XXL','XXXL'];
var BANDS={
  top:   [['XS',0,90],['S',90,98],['M',98,106],['L',106,114],['XL',114,122],['XXL',122,999]],
  bottom:[['XS',0,76],['S',76,82],['M',82,88],['L',88,94],['XL',94,100],['XXL',100,999]]
};
function bandsFor(g){return BANDS[g==='bottom'?'bottom':'top'];}
function fitOffset(){return {fitted:-3.5,regular:0,relaxed:4}[q.fit]||0;} /* pasvoorkeur-modifier */
function drivingMeasure(g,est){return g==='bottom'?est.waist:est.chest;}
function nearestAvailable(name){
  var sizes=sizeList();
  if(sizes.indexOf(name)>=0)return name;
  var ii=SIZE_ORDER.indexOf(name),best=null,bd=99;
  sizes.forEach(function(s){var oi=SIZE_ORDER.indexOf(s);if(oi<0)return;var d=Math.abs(oi-ii);if(d<bd){bd=d;best=s;}});
  return best||sizes[0];
}
/* ---------- Pasvorm-correctie per kledingstuk (uit retourdata, augustus 2026) ----------
   De banden hierboven kijken alleen naar het LICHAAM. Maar maat M van een strakke dames-top
   is 34 cm breed en maat M van een oversized heren-longsleeve 68 cm: bijna twee keer zoveel
   stof, terwijl de quiz bij allebei hetzelfde advies gaf. Dat is waar de retouren vandaan komen.

   We corrigeren daarom op de maat van het kledingstuk ZELF, niet op de productnaam. Reden:
   een nieuwe collectie brengt zijn eigen maattabel mee en krijgt de juiste correctie dus
   automatisch, zonder dat iemand een lijst hoeft bij te houden.

   Grenzen gekalibreerd op 3.416 echte retouren (bewuste dubbelbestellingen eruit gefilterd),
   correlatie tabelmaat <-> pasvormsignaal = +0,79 bij tops. */
var PASVORM={
  top:   [[36,+1],[60,0],[999,-1]],   /* <36 cm valt klein · 36-60 normaal · >=60 valt ruim */
  bottom:[[38,0],[999,-1]]            /* <38 cm normaal · >=38 valt ruim */
};
function maatKolom(ch){
  var re=ch.g==='bottom'?/waist/i:/chest/i;
  for(var i=0;i<ch.cols.length;i++){ if(re.test(ch.cols[i])) return i; }
  return -1;
}
/* Hoe ruim valt dit kledingstuk? -1 = maat kleiner, 0 = ongewijzigd, +1 = maat groter. */
/* Rekbare stukken (zwemkleding, ondergoed) volgen deze logica niet: de tabelmaat zegt daar
   weinig over hoe het zit. Die laten we met rust. */
var GEEN_CORRECTIE=/SWIM|UNDERWEAR|BIKINI|BRALETTE|BRIEF|BOXER|SOCK/i;
function pasvormCorrectie(ch){
  try{
    if(ch._fallback) return 0;                       /* geen echte maattabel: niet gokken */
    if(GEEN_CORRECTIE.test(P.type||'')||GEEN_CORRECTIE.test(P.handle||'')) return 0;
    var ci=maatKolom(ch); if(ci<0) return 0;
    var rij=ch.rows.M||ch.rows.L||ch.rows.S; if(!rij||rij[ci]==null) return 0;
    var v=+rij[ci], tab=PASVORM[ch.g==='bottom'?'bottom':'top'];
    for(var i=0;i<tab.length;i++){ if(v<tab[i][0]) return tab[i][1]; }
    return 0;
  }catch(e){ return 0; }
}
function schuifMaat(naam,stappen){
  var i=SIZE_ORDER.indexOf(naam); if(i<0) return naam;
  return SIZE_ORDER[Math.max(0,Math.min(SIZE_ORDER.length-1,i+stappen))];
}
var PASNOTE={
  en:{ruim:'This style runs large, so we recommend one size down.',krap:'This style runs small, so we recommend one size up.'},
  nl:{ruim:'Deze pasvorm valt ruim, daarom adviseren we een maat kleiner.',krap:'Deze pasvorm valt klein, daarom adviseren we een maat groter.'},
  de:{ruim:'Dieses Modell faellt gross aus, daher empfehlen wir eine Nummer kleiner.',krap:'Dieses Modell faellt klein aus, daher empfehlen wir eine Nummer groesser.'},
  es:{ruim:'Esta prenda queda grande, por eso recomendamos una talla menos.',krap:'Esta prenda queda pequena, por eso recomendamos una talla mas.'},
  fr:{ruim:'Ce modele taille grand, nous conseillons donc une taille en dessous.',krap:'Ce modele taille petit, nous conseillons donc une taille au-dessus.'}
};
function recommend(){
  var ch=chart(),est=q.est||estimate(),g=ch.g;
  var m=drivingMeasure(g,est)+fitOffset(), b=bandsFor(g), i=b.length-1;
  for(var k=0;k<b.length;k++){ if(m<b[k][2]){ i=k; break; } }
  var lo=b[i][1],hi=b[i][2],edgeUp=hi-m,edgeDn=m-lo;
  var ideal=b[i][0],borderline=false,note='';
  var corr=pasvormCorrectie(ch);
  /* Zit iemand op de grens, dan rondden we bij tops altijd omhoog af. Bij een kledingstuk dat
     ruim valt is dat juist de verkeerde kant op, dus dat doen we alleen nog als het niet ruim valt. */
  if(g!=='bottom'&&corr>=0&&edgeUp<=2&&i<b.length-1){ borderline=true; ideal=b[i+1][0];
    note=T('note_suggest').replace(/\{a\}/g,b[i][0]).replace(/\{b\}/g,b[i+1][0]); }
  else if(edgeUp<=2&&i<b.length-1){ borderline=true; note=T('note_between').replace('{a}',b[i][0]).replace('{b}',b[i+1][0]); }
  else if(edgeDn<=2&&i>0){ borderline=true; note=T('note_between').replace('{a}',b[i-1][0]).replace('{b}',b[i][0]); }
  if(corr){ ideal=schuifMaat(ideal,corr);
    var pn=(PASNOTE[LANG]||PASNOTE.en); note=corr<0?pn.ruim:pn.krap; }
  var size=nearestAvailable(ideal);
  var conf=borderline?'medium':(Math.min(edgeUp,edgeDn)<4?'medium':'high');
  if(q.anchor&&q.anchor.brand&&q.anchor.size&&g!=='bottom')conf='high';
  return {size:size,ideal:ideal,est:est,ch:ch,conf:conf,borderline:borderline,note:note,corr:corr};
}
function primaryFit(sz){
  var ch=chart(),est=q.est||estimate();
  var m=(ch.g==='bottom'?est.waist:est.chest)+fitOffset(), b=bandsFor(ch.g), band=null;
  for(var i=0;i<b.length;i++)if(b[i][0]===sz){band=b[i];break;}
  if(!band)return 'perfect';
  if(m<band[1])return 'loose';
  if(m>=band[2])return 'tight';
  return 'perfect';
}

/* ---------- styles ---------- */
var CSS='\
.qsq-open{display:flex;align-items:center;justify-content:center;gap:7px;width:100%;font:inherit;font-size:14px;font-weight:400;letter-spacing:.01em;color:#0b0b0c;background:none;border:0;padding:10px 0;cursor:pointer;margin:0;text-decoration:none;font-family:inherit}\
.qsq-open:hover{opacity:.6}\
.qsq-open svg{width:15px;height:15px}\
.qsq-mysize{display:flex;align-items:center;justify-content:center;gap:7px;width:100%;box-sizing:border-box;background:none;color:#0b0b0c;font:inherit;font-family:inherit;font-size:14px;font-weight:400;letter-spacing:.01em;padding:10px 0;border:0;cursor:pointer;margin:0;text-decoration:none}\
.qsq-mysize:hover{opacity:.6}\
.qsq-mysize svg{width:15px;height:15px;flex:none}\
.qsq-mysize b{font-weight:600}\
.qsq-mysize .qm-q{display:inline-grid;place-items:center;width:15px;height:15px;border-radius:50%;border:1px solid #b7b4ae;color:#6b6864;font-size:10px;line-height:1;margin-left:2px}\
.qsq-mysize-wrap{position:relative}\
.qsq-tip{position:absolute;bottom:calc(100% + 12px);left:50%;transform:translateX(-50%);z-index:2147482000;width:270px;max-width:84vw;background:#fff;color:#0b0b0c;border:1px solid #e6e4df;box-shadow:0 16px 44px -14px rgba(0,0,0,.4);padding:16px 16px 15px;border-radius:0;font-family:inherit;line-height:1.5;text-align:left}\
.qsq-tip[hidden]{display:none}\
.qsq-tip h5{margin:0 0 8px;font-size:14px;font-weight:600;padding-right:18px;letter-spacing:-.01em}\
.qsq-tip p{margin:0;font-size:12.5px;color:#6b6864}\
.qsq-tip .tx{position:absolute;top:9px;right:10px;border:0;background:none;font-size:18px;color:#9b9894;cursor:pointer;line-height:1;font-family:inherit;padding:2px}\
.qsq-tip:after{content:"";position:absolute;bottom:-7px;left:50%;margin-left:-6px;width:12px;height:12px;background:#fff;border-right:1px solid #e6e4df;border-bottom:1px solid #e6e4df;transform:rotate(45deg)}\
#qsq-ov{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(24,22,26,.55);padding:28px;font-family:inherit}\
#qsq-ov.on{display:flex}\
.qsq-card{background:#fff;color:#0b0b0c;width:100%;max-width:460px;max-height:90vh;border-radius:0;overflow:hidden;display:flex;box-shadow:0 30px 80px -20px rgba(0,0,0,.5);animation:qsqp .28s cubic-bezier(.4,0,.2,1);line-height:1.45}\
@keyframes qsqp{from{transform:scale(.97);opacity:.4}to{transform:none;opacity:1}}\
.qsq-main{flex:1;display:flex;flex-direction:column;min-width:0;container-type:inline-size}\
.qsq-top{display:flex;align-items:center;padding:16px 18px 2px}\
.qsq-side{flex:0 0 34px;display:flex;align-items:center}\
.qsq-side.r{justify-content:flex-end}\
.qsq-logowrap{flex:1;text-align:center;line-height:0}\
.qsq-logo{height:16px;width:auto;display:inline-block;vertical-align:middle}\
.qsq-ttl{font-weight:600;letter-spacing:-.01em;text-transform:uppercase;font-size:14px}\
.qsq-x,.qsq-back{border:0;background:none;color:#6b6864;font-size:19px;cursor:pointer;padding:3px;font-family:inherit}\
.qsq-back{font-size:13px;font-weight:600}\
.qsq-body{padding:16px 22px 22px;overflow-y:auto;flex:1}\
.qsq-h{font-size:18px;font-weight:600;text-align:center;letter-spacing:-.01em;margin:6px 0 2px}\
.qsq-lede{font-size:13px;color:#6b6864;text-align:center;margin:2px 0 16px}\
.qsq-f{margin-bottom:14px}\
.qsq-fl{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px}\
.qsq-fl .k{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#6b6864}\
.qsq-fl .v{font-size:17px;font-weight:600}.qsq-fl .v small{font-size:11px;color:#6b6864;margin-left:2px}\
.qsq-rg{-webkit-appearance:none!important;appearance:none!important;width:100%;height:2px!important;background:#d8d5cf!important;border:0!important;border-radius:0!important;padding:0!important;margin:12px 0}\
.qsq-rg::-webkit-slider-runnable-track{height:2px;background:#d8d5cf;border:0}\
.qsq-rg::-moz-range-track{height:2px;background:#d8d5cf;border:0}\
.qsq-rg::-webkit-slider-thumb{-webkit-appearance:none;width:18px;height:18px;margin-top:-8px;border-radius:50%;background:#0b0b0c;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.35);cursor:pointer}\
.qsq-rg::-moz-range-thumb{width:16px;height:16px;border-radius:50%;background:#0b0b0c;border:2px solid #fff;cursor:pointer}\
.qsq-seg{margin-bottom:14px}\
.qsq-seg .k{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#6b6864;display:block;margin-bottom:7px}\
.qsq-seg .row{display:flex;gap:8px}\
.qsq-seg button{flex:1;font:inherit;font-family:inherit;background:#fff;border:1px solid #d8d5cf;border-radius:0;padding:11px 4px;cursor:pointer;color:#6b6864;font-size:12.5px;font-weight:600}\
.qsq-seg button.on{color:#0b0b0c;border-color:#0b0b0c;box-shadow:inset 0 0 0 1px #0b0b0c}\
.qsq-seg button.img{display:flex;flex-direction:column;align-items:center;gap:3px;padding:9px 4px 8px;line-height:1.1}\
.qsq-seg button.img img{width:100%;max-width:46px;height:58px;object-fit:contain;pointer-events:none;opacity:.82}\
.qsq-seg button.img.on img{opacity:1}\
.qsq-anchor{display:flex;gap:8px}\
.qsq-anchor select{flex:1;min-width:0;font:inherit;font-family:inherit;border:1px solid #d8d5cf;border-radius:0;padding:11px 8px;background:#fff;font-size:12.5px;color:#0b0b0c;-webkit-appearance:none;appearance:none}\
.qsq-cta{width:100%;font:inherit;font-size:14px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;padding:16px;border-radius:0;border:0;background:#0b0b0c;color:#fff;cursor:pointer;font-family:inherit;margin-top:4px}\
.qsq-unit{display:flex;justify-content:flex-end;margin-bottom:10px}\
.qsq-up{display:inline-flex;background:#f6f5f2;border:1px solid #d8d5cf;border-radius:0;padding:2px}\
.qsq-up button{font:inherit;font-size:11px;font-weight:600;text-transform:uppercase;border:0;background:none;color:#6b6864;padding:4px 12px;border-radius:0;cursor:pointer;font-family:inherit}\
.qsq-up button.on{background:#0b0b0c;color:#fff}\
.qsq-load{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:300px;gap:16px;text-align:center}\
.qsq-spin{width:52px;height:52px;border-radius:50%;border:5px solid #d8d5cf;border-top-color:#0b0b0c;animation:qsqs 1s linear infinite}@keyframes qsqs{to{transform:rotate(360deg)}}\
.qsq-rsize{font-size:56px;font-weight:600;letter-spacing:-.04em;line-height:.9;margin:6px 0 4px;text-align:center}\
.qsq-reb{font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:#6b6864;text-align:center}\
.qsq-conf{display:inline-flex;align-items:center;gap:5px;font-size:10.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;padding:3px 9px;border-radius:0;margin:8px auto 0}\
.qsq-conf .cd{width:6px;height:6px;border-radius:50%}\
.qsq-conf.high{background:#e9f3ee;color:#2f7d55}.qsq-conf.high .cd{background:#2f7d55}\
.qsq-conf.medium{background:#f6eede;color:#b07b2c}.qsq-conf.medium .cd{background:#b07b2c}\
.qsq-hem{position:absolute;left:6%;right:6%;height:0;border-top:2px dashed #1e1e20;opacity:.55}\
.qsq-hl{position:absolute;right:2%;transform:translateY(-50%);font-size:11px;font-weight:600;color:#1e1e20;background:rgba(255,255,255,.85);padding:1px 5px;border-radius:4px}\
.qsq-fitline{font-size:13px;color:#1e1e20;text-align:center;margin:14px 6px 2px;line-height:1.5}\
.qsq-fitline b{font-weight:600}\
.qsq-edit{display:block;margin:6px auto 0;font-size:12px;font-weight:600;color:#6b6864;background:none;border:0;text-decoration:underline;cursor:pointer;font-family:inherit}\
.qsq-map{position:relative;margin:16px auto 8px;width:100%;max-width:212px}\
.qsq-map img,.qsq-map svg{width:100%;height:auto;display:block}\
.qsq-band{position:absolute;left:24%;width:40%;height:3px;transform:translateY(-50%);z-index:1}\
.qsq-zl{position:absolute;transform:translateY(-50%);left:64%;z-index:2;display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;padding:3px 7px;border-radius:0;white-space:nowrap}\
.qsq-zl .zd{width:6px;height:6px;border-radius:50%}\
.qsq-zl.perfect{background:#e9f3ee;color:#2f7d55}.qsq-zl.perfect .zd{background:#2f7d55}\
.qsq-zl.tight{background:#f7e9e9;color:#b23b3b}.qsq-zl.tight .zd{background:#b23b3b}\
.qsq-zl.loose{background:#f6eede;color:#b07b2c}.qsq-zl.loose .zd{background:#b07b2c}\
.qsq-pills{display:flex;gap:6px;justify-content:center;flex-wrap:wrap;margin-top:12px}\
.qsq-pills button{font:inherit;font-size:13px;font-weight:600;min-width:44px;padding:9px 4px;border-radius:0;border:1px solid #d8d5cf;background:#fff;color:#6b6864;cursor:pointer;font-family:inherit}\
.qsq-pills button.on{color:#0b0b0c;border-color:#0b0b0c}\
.qsq-view{display:block;width:100%;text-align:center;margin-top:11px;font-size:11.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#6b6864;background:none;border:0;cursor:pointer;font-family:inherit}\
.qsq-tabs{display:flex;gap:20px;border-bottom:1px solid #e6e4df;margin:8px 0 14px}\
.qsq-tab{font-size:12.5px;font-weight:600;padding:0 0 10px;color:#9b9894;cursor:pointer;border:0;border-bottom:2px solid transparent;margin-bottom:-1px;background:none;font-family:inherit}\
.qsq-tab.on{color:#0b0b0c;border-bottom-color:#0b0b0c}\
table.qsq-t{border-collapse:collapse;width:100%}\
table.qsq-t th,table.qsq-t td{text-align:left;padding:11px 8px;border-bottom:1px solid #e6e4df;font-size:12.5px}\
table.qsq-t thead th{font-size:10px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#6b6864}\
table.qsq-t tbody td:first-child{font-weight:600}\
table.qsq-t tbody tr.hl td{background:#f6f5f2}\
.qsq-note{font-size:11px;color:#9b9894;margin-top:10px;text-align:center}\
.qsq-model{display:flex;gap:7px;align-items:center;justify-content:center;font-size:11.5px;color:#6b6864;margin-top:14px;text-align:center}\
.qsq-model svg{width:14px;height:14px;flex:none;opacity:.7}\
@media(max-width:680px){\
  #qsq-ov{padding:0}\
  .qsq-card{max-width:none!important;width:100vw;height:100%;max-height:none;border-radius:0;flex-direction:column;box-shadow:none;animation:none}\
}';
function css(){if(document.getElementById('qsq-style'))return;var s=document.createElement('style');s.id='qsq-style';s.textContent=CSS;document.head.appendChild(s);}

var MANN='<svg viewBox="0 0 200 260" fill="none"><g stroke="#e0ddd7" stroke-width="2"><circle cx="100" cy="26" r="17" fill="#f6f5f2"/><path d="M92 42h16v10h-16z" fill="#f6f5f2"/><path d="M62 60q38-14 76 0l-7 120q-31 12-62 0z" fill="#f6f5f2"/><path d="M64 64l-20 70 12 5 18-58z" fill="#f6f5f2"/><path d="M136 64l20 70-12 5-18-58z" fill="#f6f5f2"/></g></svg>';

/* ---------- overlay ---------- */
var ov,card;
function open(){buildOverlay();var prof=load();if(prof){Object.assign(q,prof);if(!q.anchor)q.anchor={brand:'',size:''};q.est=estimate();}q.step=0;ov.classList.add('on');document.documentElement.style.overflow='hidden';track('open');render();}
function close(){if(ov)ov.classList.remove('on');document.documentElement.style.overflow='';renderMount();}
function buildOverlay(){
  if(ov)return;
  ov=document.createElement('div');ov.id='qsq-ov';
  ov.innerHTML='<div class="qsq-card"><div class="qsq-main" id="qsq-main"></div></div>';
  document.body.appendChild(ov);
  card=ov.querySelector('#qsq-main');
  ov.addEventListener('click',function(e){if(e.target===ov)close();});
}
function topBar(back){return '<div class="qsq-top">'+
  '<span class="qsq-side">'+(back?'<button class="qsq-back">&#8592;</button>':'')+'</span>'+
  '<span class="qsq-logowrap"><img class="qsq-logo" src="'+IMG.logo+'" alt="Quotrell"></span>'+
  '<span class="qsq-side r"><button class="qsq-x" aria-label="Close">&times;</button></span>'+
  '</div>';}
function wireCommon(){var x=card.querySelector('.qsq-x');if(x)x.onclick=close;var b=card.querySelector('.qsq-back');if(b)b.onclick=function(){q.step=5;render();};}

/* ---------- render ---------- */
function render(){
  var s=q.step;
  if(s===0)return renderStart();
  if(s===3)return renderLoad();
  if(s==='chart')return renderChart();
  return renderResult();
}
function renderStart(){
  var uOf=function(k){return k==='h'?'cm':'kg';};
  function sl(k,mn,mx,lab){return '<div class="qsq-f"><div class="qsq-fl"><span class="k">'+lab+'</span><span class="v">'+q[k]+'<small>'+uOf(k)+'</small></span></div><input type="range" class="qsq-rg" min="'+mn+'" max="'+mx+'" value="'+q[k]+'" data-q="'+k+'"></div>';}
  function seg(key,lab,opts){return '<div class="qsq-seg"><span class="k">'+lab+'</span><div class="row">'+
    opts.map(function(o){var sm=shapeMap();var im=sm[key]&&sm[key][o[0]];return '<button data-seg="'+key+'" data-val="'+o[0]+'" class="'+(q[key]===o[0]?'on':'')+(im?' img':'')+'">'+(im?'<img src="'+im+'" alt="" loading="lazy">':'')+'<span>'+o[1]+'</span></button>';}).join('')+'</div></div>';}
  card.innerHTML=topBar(false)+'<div class="qsq-body">'+
    '<div class="qsq-h">'+T('find_h')+'</div><p class="qsq-lede">'+T('find_sub')+'</p>'+
    sl('h',150,210,T('height'))+sl('w',45,140,T('weight'))+
    seg('frame',T('build'),[['slim',T('slim')],['average',T('average')],['broad',T('broad')]])+
    seg('waist',T('waist'),[['slim',T('slim')],['average',T('average')],['full',T('fuller')]])+
    seg('fit',T('fit'),[['fitted',T('fitted')],['regular',T('regular')],['relaxed',T('relaxed')]])+
    '<button class="qsq-cta" data-find>'+T('find_cta')+'</button></div>';
  wireCommon();
  card.querySelectorAll('input[type=range]').forEach(function(r){r.oninput=function(){q[r.dataset.q]=+r.value;q.est=null;var v=r.parentElement.querySelector('.v');if(v)v.innerHTML=r.value+'<small>'+uOf(r.dataset.q)+'</small>';};});
  card.querySelectorAll('[data-seg]').forEach(function(b){b.onclick=function(){var key=b.dataset.seg;q[key]=b.dataset.val;q.est=null;card.querySelectorAll('[data-seg="'+key+'"]').forEach(function(x){x.classList.toggle('on',x===b);});};});
  card.querySelector('[data-find]').onclick=function(){q.step=3;render();setTimeout(function(){q.est=estimate();save(profileObj());q.chosen=null;
    try{var rc=recommend();onthoudInOrder(rc);track('complete',{rec:rc.size,conf:rc.conf,h:q.h,w:q.w,build:q.frame,waist:q.waist,fit:q.fit,est:Math.round(rc.ch.g==='bottom'?rc.est.waist:rc.est.chest),brand:q.anchor.brand||'',asize:q.anchor.size||'',unit:q.unit});}catch(e){}
    q.step=5;render();},1100);};
}
function renderLoad(){card.innerHTML=topBar(false)+'<div class="qsq-body"><div class="qsq-load"><div class="qsq-spin"></div><h4 style="margin:0;font-size:15px;font-weight:600">'+T('loading_h')+'</h4><p style="margin:0;font-size:12.5px;color:#6b6864">'+T('loading_sub')+'</p></div></div>';wireCommon();}
/* Pasvormadvies per productgroep, gebaseerd op de retourdata van april t/m juli 2026.
   Dames broeken kwamen 135x terug als te groot tegen 41x te klein; unisex artikelen
   vielen ruim voor zowel mannen als vrouwen. Alleen de pasvorm, niet de lengte:
   tussen twee maten zit maar 1 a 2 cm beenlengte, dus daar helpt een maat kleiner niet voor. */
var FITNOTE={
  en:{ruim:'<b>Runs roomy.</b> We recommend taking one size smaller.',
      unisex:'<b>Oversized unisex fit</b>, cut on a men\'s block. Women: we recommend one size smaller.'},
  nl:{ruim:'<b>Valt ruim.</b> Wij adviseren een maat kleiner te nemen.',
      unisex:'<b>Oversized unisex pasvorm</b>, gesneden op een herenmaat. Dames: neem een maat kleiner.'},
  de:{ruim:'<b>Fällt weit aus.</b> Wir empfehlen eine Nummer kleiner.',
      unisex:'<b>Oversized Unisex-Passform</b>, auf Herrenschnitt. Damen: eine Nummer kleiner.'},
  es:{ruim:'<b>Talla grande.</b> Recomendamos elegir una talla menos.',
      unisex:'<b>Corte unisex oversize</b>, patrón masculino. Mujeres: una talla menos.'},
  fr:{ruim:'<b>Taille grand.</b> Nous conseillons de prendre une taille en dessous.',
      unisex:'<b>Coupe unisexe oversize</b>, patronage homme. Femmes: une taille en dessous.'}
};
function fitAdvies(g,maat){
  try{
    var gd=(P.gender||'').toLowerCase();
    var t=FITNOTE[LANG]||FITNOTE.en;
    /* Staat het advies al op de kleinste beschikbare maat, dan is 'neem een maat kleiner'
       onzinnig. Dan tonen we niets. */
    if(maat){
      var lijst=sizeList();
      if(lijst.length&&lijst[0]===maat) return '';
    }
    if(gd==='unisex') return t.unisex;
    if(gd==='women'&&g==='bottom') return t.ruim;
    return '';
  }catch(e){ return ''; }
}
/* Beenlengte in beeld brengen. De maattabel van een broek heeft een lengtekolom
   (Outside length). Die zetten we af tegen de taille-tot-vloer van de klant,
   ongeveer 0,61 x de lichaamslengte. Zo zie je of de zoom op de enkel of op de grond valt. */
function lengteKolom(ch){
  if(!ch||!ch.cols) return -1;
  for(var i=0;i<ch.cols.length;i++){ if(/outside length|inseam|leg length/i.test(ch.cols[i])) return i; }
  return -1;
}
function zoomMarkering(ch,maat,zone){
  try{
    if(ch.g!=='bottom'||!q.h) return {html:'',note:''};
    var i=lengteKolom(ch); if(i<0) return {html:'',note:''};
    var rij=ch.rows[maat]; if(!rij||rij[i]==null) return {html:'',note:''};
    var lengte=+rij[i];
    var tailleVloer=0.61*(+q.h);                    /* taille tot vloer, ruwe schatting */
    var boven=tailleVloer-lengte;                   /* hoeveel cm de zoom boven de vloer eindigt */
    var f=lengte/tailleVloer;
    var pos=Math.min(99, zone+Math.max(0,Math.min(1.02,f))*(99-zone));
    var t=(LENGTE[LANG]||LENGTE.en);
    var label=Math.round(lengte)+' cm';
    /* enkelbot zit ongeveer 7 cm boven de vloer */
    var note = boven<=1 ? t.vloer : (boven<=5 ? t.schoen : (boven<=10 ? t.enkel : t.cropped));
    return {
      html:'<div class="qsq-hem" style="top:'+pos.toFixed(1)+'%"></div>'+
           '<div class="qsq-hl" style="top:'+pos.toFixed(1)+'%">'+label+'</div>',
      note:note
    };
  }catch(e){ return {html:'',note:''}; }
}
var LENGTE={
  en:{vloer:'This length reaches the floor at your height.',
      schoen:'At your height this length falls over the ankle, onto the shoe.',
      enkel:'At your height this length falls right at the ankle.',
      cropped:'At your height this length falls above the ankle.'},
  nl:{vloer:'Bij jouw lengte komt deze broek tot op de grond.',
      schoen:'Bij jouw lengte valt deze broek over je enkel, op je schoen.',
      enkel:'Bij jouw lengte valt deze broek precies op je enkel.',
      cropped:'Bij jouw lengte valt deze broek boven je enkel.'},
  de:{vloer:'Bei deiner Groesse reicht diese Laenge bis zum Boden.',
      schoen:'Bei deiner Groesse faellt diese Laenge ueber den Knoechel auf den Schuh.',
      enkel:'Bei deiner Groesse endet diese Laenge genau am Knoechel.',
      cropped:'Bei deiner Groesse endet diese Laenge ueber dem Knoechel.'},
  es:{vloer:'Con tu altura este largo llega al suelo.',
      schoen:'Con tu altura este largo cae sobre el tobillo, encima del zapato.',
      enkel:'Con tu altura este largo cae justo en el tobillo.',
      cropped:'Con tu altura este largo cae por encima del tobillo.'},
  fr:{vloer:'A votre taille, cette longueur touche le sol.',
      schoen:'A votre taille, cette longueur tombe sur la cheville, sur la chaussure.',
      enkel:'A votre taille, cette longueur tombe juste a la cheville.',
      cropped:'A votre taille, cette longueur tombe au-dessus de la cheville.'}
};
/* Zit iemand tussen twee maten op een broek, dan is het onduidelijk wat te doen. De maattabel
   geeft het antwoord: een maat groter levert veel taille op en nauwelijks lengte, en te wijd is
   waar de retouren vandaan komen. Dus vertellen we expliciet naar beneden af te ronden. */
var TUSSEN={
  en:'You are between {a} and {b}. We recommend {a}: one size up adds {w} cm at the waist but only {l} cm in length.',
  nl:'Je zit tussen {a} en {b}. Wij adviseren {a}: een maat groter geeft {w} cm meer taille maar maar {l} cm meer lengte.',
  de:'Du liegst zwischen {a} und {b}. Wir empfehlen {a}: eine Nummer groesser bringt {w} cm mehr Bund, aber nur {l} cm mehr Laenge.',
  es:'Estas entre {a} y {b}. Recomendamos {a}: una talla mas anade {w} cm de cintura pero solo {l} cm de largo.',
  fr:'Vous etes entre {a} et {b}. Nous conseillons {a}: une taille au-dessus ajoute {w} cm a la taille mais seulement {l} cm de longueur.'
};
function tussenAdvies(ch,maat){
  try{
    if(ch.g!=='bottom') return '';
    var lijst=sizeList(), i=lijst.indexOf(maat);
    if(i<0||i+1>=lijst.length) return '';
    var groter=lijst[i+1], a=ch.rows[maat], b=ch.rows[groter];
    if(!a||!b) return '';
    var li=lengteKolom(ch); if(li<0) return '';
    var wi=-1; for(var k=0;k<ch.cols.length;k++){ if(/waist/i.test(ch.cols[k])) wi=k; }
    if(wi<0) return '';
    var dw=Math.round((b[wi]-a[wi])*2), dl=Math.round(b[li]-a[li]);   /* taille plat -> rondom */
    if(dw<=0) return '';
    return (TUSSEN[LANG]||TUSSEN.en).replace(/\{a\}/g,maat).replace('{b}',groter).replace('{w}',dw).replace('{l}',dl);
  }catch(e){ return ''; }
}
function renderResult(){
  var rec=recommend(),ch=rec.ch,chosen=q.chosen||rec.size;q.chosen=chosen;
  stampFit(rec);
  var fit=chosen?primaryFit(chosen):'na';
  var beeld=bodyBeeld(ch.g);
  var zonePct=beeld.zone;
  var col=fit==='perfect'?'#2f7d55':fit==='tight'?'#b23b3b':'#b07b2c';
  var txt=fit==='perfect'?'perfect':fit==='tight'?'too tight':'too loose';
  var torso=beeld.src?('<img src="'+beeld.src+'" alt="" onerror="this.style.display=\'none\'">'):MANN;
  var zoom=zoomMarkering(ch,chosen||rec.size,zonePct);
  var map=torso+'<div class="qsq-band" style="top:'+zonePct+'%;background:'+col+'"></div>'+
    '<div class="qsq-zl '+fit+'" style="top:'+zonePct+'%"><span class="zd"></span>'+txt+'</div>'+zoom.html;
  var zoneName=ch.g==='bottom'?T('zone_waist'):T('zone_chest');
  var qual=fit==='perfect'?T('fit_just'):fit==='tight'?T('fit_snug'):T('fit_roomy');
  var sentence=chosen?T('fit_sentence').replace('{size}',chosen).replace('{q}',qual).replace('{zone}',zoneName):'';
  var isRec=chosen===rec.size;
  var conf=isRec?('<div class="qsq-conf '+rec.conf+'"><span class="cd"></span>'+(rec.conf==='high'?T('conf_high'):T('conf_between'))+'</div>'):'';
  var noteLine=(isRec&&rec.note)?('<p class="qsq-fitline" style="color:#6b6864;margin-top:6px">'+rec.note+'</p>'):'';
  var advies=fitAdvies(ch.g,chosen||rec.size);
  if(rec.borderline&&isRec){ var ta=tussenAdvies(ch,chosen||rec.size); if(ta) advies=(advies?advies+'<br>':'')+ta; }
  if(zoom.note) advies=(advies?advies+'<br>':'')+zoom.note;
  var adviesLine=advies?('<p class="qsq-fitline" style="margin-top:10px;padding:9px 12px;background:#f6f5f2;border-radius:8px">'+advies+'</p>'):'';
  card.innerHTML=topBar(false)+'<div class="qsq-body" style="text-align:center">'+
    '<div class="qsq-reb">'+T('rec_label')+'</div><div class="qsq-rsize">'+(chosen||'?')+'</div>'+conf+
    '<button class="qsq-edit" data-edit>'+T('edit')+'</button>'+adviesLine+
    '<div class="qsq-map">'+map+'</div>'+
    '<p class="qsq-fitline">'+sentence+'</p>'+noteLine+
    '<div class="qsq-pills">'+sizeList().map(function(sz){return '<button data-sz="'+sz+'" class="'+(sz===chosen?'on':'')+'">'+sz+'</button>';}).join('')+'</div>'+
    '<button class="qsq-cta" style="margin-top:14px" data-add>'+T('add_cta').replace('{size}',chosen)+'</button>'+
    '<button class="qsq-view" data-chart>'+T('view_chart')+'</button>'+modelNote()+'</div>';
  wireCommon();
  card.querySelector('[data-edit]').onclick=function(){q.step=0;render();};
  card.querySelectorAll('[data-sz]').forEach(function(b){b.onclick=function(){if(b.dataset.sz!==rec.size)track('override',{rec:rec.size,chosen:b.dataset.sz,h:q.h,w:q.w,build:q.frame,waist:q.waist,fit:q.fit,est:Math.round(rec.ch.g==='bottom'?rec.est.waist:rec.est.chest)});q.chosen=b.dataset.sz;render();};});
  card.querySelector('[data-add]').onclick=function(){track('add_to_cart',{rec:rec.size,chosen:chosen,est:Math.round(rec.ch.g==='bottom'?rec.est.waist:rec.est.chest)});stampFit(rec);onthoudInOrder(rec);selectSize(chosen);close();setTimeout(addToCart,320);};
  card.querySelector('[data-chart]').onclick=function(){track('view_chart');q.step='chart';render();};
}
var chartTab='guide';
function renderChart(){
  var ch=chart(),hl=recommend().size;
  var uni=q.unit==='cm'?'cm':'in';
  var body='';
  var adv=fitAdvies(ch.g,hl);
  if(adv) body+='<p class="qsq-fitline" style="margin:0 0 12px;padding:9px 12px;background:#f6f5f2;border-radius:8px;text-align:left">'+adv+'</p>';
  if(chartTab==='guide'){
    var fh=window.QTL_SC_FIGHTML&&window.QTL_SC_FIGHTML(ch.cols,ch.g,P.handle);
    if(fh) body+='<div class="qsq-fig" style="position:relative;max-width:230px;margin:0 auto 14px;aspect-ratio:1/1">'+fh+'</div>';
    body+='<div class="qsq-unit"><div class="qsq-up"><button data-u="cm" class="'+(q.unit==='cm'?'on':'')+'">cm</button><button data-u="in" class="'+(q.unit==='in'?'on':'')+'">in</button></div></div>';
    body+='<div style="overflow-x:auto"><table class="qsq-t"><thead><tr><th>Size</th>'+ch.cols.map(function(c,i){return '<th>'+(fh?'<span style="display:inline-block;vertical-align:1px;border:1px solid #000;border-radius:999px;min-width:15px;height:15px;line-height:14px;font-size:9px;font-weight:700;text-align:center;margin-right:5px">'+'ABCDE'[i]+'</span>':'')+c+'<br><span style="color:#9b9894">('+uni+')</span></th>';}).join('')+'</tr></thead><tbody>';
    sizeList().forEach(function(sz){var r=ch.rows[sz];if(!r)return;body+='<tr class="'+(sz===hl?'hl':'')+'"><td>'+sz+'</td>'+r.map(function(v){return '<td>'+(v==null?'&middot;':disp(v))+'</td>';}).join('')+'</tr>';});
    body+='</tbody></table></div><div class="qsq-note">'+T('chart_note')+'</div>'+modelNote();
  }else{
    var how=ch.g==='bottom'?[[T('m_waist_t'),T('m_waist_d')],[T('m_crotch_t'),T('m_crotch_d')],[T('m_outside_t'),T('m_outside_d')]]:[[T('m_chest_t'),T('m_chest_d')],[T('m_length_t'),T('m_length_d')],[T('m_sleeve_t'),T('m_sleeve_d')]];
    how.forEach(function(m){body+='<div style="padding:13px 0;border-bottom:1px solid #e6e4df"><h4 style="margin:0 0 3px;font-size:13px;font-weight:600">'+m[0]+'</h4><p style="margin:0;font-size:12.5px;color:#6b6864">'+m[1]+'</p></div>';});
  }
  card.innerHTML='<div class="qsq-top"><span class="qsq-side"><button class="qsq-back">&#8592;</button></span><span class="qsq-logowrap"><img class="qsq-logo" src="'+IMG.logo+'" alt="Quotrell"></span><span class="qsq-side r"><button class="qsq-x">&times;</button></span></div>'+
    '<div style="padding:0 22px"><div class="qsq-tabs"><button class="qsq-tab '+(chartTab==='guide'?'on':'')+'" data-tab="guide">'+T('tab_chart')+'</button><button class="qsq-tab '+(chartTab==='htm'?'on':'')+'" data-tab="htm">'+T('tab_htm')+'</button></div></div>'+
    '<div class="qsq-body" style="padding-top:0">'+body+'</div>';
  card.querySelector('.qsq-x').onclick=close;
  card.querySelector('.qsq-back').onclick=function(){q.step=5;render();};
  card.querySelectorAll('.qsq-tab').forEach(function(b){b.onclick=function(){chartTab=b.dataset.tab;renderChart();};});
  card.querySelectorAll('[data-u]').forEach(function(b){b.onclick=function(){q.unit=b.dataset.u;renderChart();};});
}

/* ---------- PDP integratie ---------- */
function selectSize(sz){
  try{
    var labels=document.querySelectorAll('.radio__button label, .product__selectors label, [data-product-variants] label');
    for(var i=0;i<labels.length;i++){
      var txt=(labels[i].textContent||'').trim();
      if(txt.toUpperCase()===sz.toUpperCase()){var inp=document.getElementById(labels[i].getAttribute('for'));if(inp){inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));}labels[i].click();return true;}
    }
  }catch(e){}
  return false;
}
// Zet het maatadvies als verborgen eigenschap op het productformulier, zodat het meeloopt
// naar de Shopify-order. Daarmee is achteraf te zien wat de maatwijzer adviseerde bij een retour.
/* Schaduwberekening. Verandert niets aan wat de klant ziet: hij rekent alleen mee op de
   achtergrond en het resultaat gaat als extra veld mee op de order. In september leggen we
   naast de retouren welke van de twee formules het beter deed.
   Verschil met de huidige: de taille en borst volgen de BMI in plaats van lengte los op te
   tellen, en de keuzes voor bouw/taille/pasvoorkeur zijn samen begrensd op 4 cm. */
function schaduwSchatting(){
  var h=+q.h, w=+q.w;
  if(!h||!w) return null;
  var bmi=w/Math.pow(h/100,2);
  var grens=function(x){ return Math.max(-4,Math.min(4,x)); };
  var wb={slim:-2,average:0,full:4}[q.waist]||0;
  var fb={slim:-2.5,average:0,broad:3.5}[q.frame]||0;
  var ft={fitted:-2,regular:0,relaxed:2.5}[q.fit]||0;
  return { waist:h*(0.10+0.0149*bmi)+grens(wb+ft), chest:h*(0.285+0.0113*bmi)+grens(fb+ft) };
}
function schaduwMaat(g){
  try{
    var e=schaduwSchatting(); if(!e) return '';
    var m=(g==='bottom')?e.waist:e.chest;
    var b=bandsFor(g), i=b.length-1;
    for(var k=0;k<b.length;k++){ if(m<b[k][2]){ i=k; break; } }
    return nearestAvailable(b[i][0]);
  }catch(e){ return ''; }
}
/* ---------- Maatwijzer-gebruik op de order vastleggen ----------
   stampFit() zet een hidden input in het cart-formulier, maar dit theme voegt producten via
   JavaScript toe en negeert dat veld: van 14.692 verkochte stuks droeg er nul het stempel.
   Order-attributen komen wel door (228 van 250 orders dragen er al). Daarom schrijven we het
   daarheen, zodat we later kunnen meten of quiz-gebruikers minder retourneren.
   Fire-and-forget: mislukt dit, dan merkt de klant er niets van. */
function onthoudInOrder(rec){
  try{
    var adv=(rec&&rec.size)||'-', gek=q.chosen||'';
    var h=(P.handle||'').slice(0,50);
    var deel=h+':'+adv+(gek&&gek!==adv?('>'+gek):'')+(rec&&rec.corr?('c'+rec.corr):'');
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var oud=((cart.attributes||{}).maatwijzer)||'';
        if(oud.indexOf(deel)>=0) return;                    /* al identiek vastgelegd */
        /* eerdere registratie van hetzelfde product vervangen, niet ernaast zetten */
        var delen=oud?oud.split('; ').filter(function(x){return x.indexOf(h+':')!==0;}):[];
        delen.push(deel);
        var nieuw=delen.join('; ');
        if(nieuw.length>480) nieuw=nieuw.slice(-480);        /* attribuut kort houden */
        return fetch('/cart/update.js',{method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({attributes:{maatwijzer:nieuw,
            maatwijzer_lichaam:(q.h||'-')+'cm '+(q.w||'-')+'kg '+(q.frame||'-')+'/'+(q.waist||'-')+'/'+(q.fit||'-')}})});
      }).catch(function(){});
  }catch(e){}
}
function stampFit(rec){
  try{
    var f=document.querySelector('form[action*="/cart/add"]');
    if(!f) return false;
    var adv=(rec&&rec.size)||'';
    var chosen=q.chosen||adv;
    var u=q.unit||'cm';
    var val='advies '+(adv||'-')+' | gekozen '+(chosen||'-')+' | '+(q.h||'-')+(u==='in'?'in':'cm')+' '+(q.w||'-')+(u==='in'?'lb':'kg')
      +' | bouw '+(q.frame||'-')+' | taille '+(q.waist||'-')+' | pasvoorkeur '+(q.fit||'-')
      +(rec&&rec.conf?' | zekerheid '+rec.conf:'')
      +(rec&&rec.ch&&rec.ch.g?' | '+rec.ch.g:'')
      +(function(){ var sm=schaduwMaat(rec&&rec.ch?rec.ch.g:'top'); return sm?' | schaduw '+sm:''; })();
    var naam='properties[_maatwijzer]';
    var el=f.querySelector('input[name="'+naam+'"]');
    if(!el){ el=document.createElement('input'); el.type='hidden'; el.name=naam; f.appendChild(el); }
    el.value=val;
    return true;
  }catch(e){ return false; }
}
function addToCart(){
  try{
    var f=document.querySelector('form[action*="/cart/add"]');
    var btn=(f&&(f.querySelector('[data-add-to-cart]')||f.querySelector('button[name="add"]')||f.querySelector('[type="submit"]')))
      ||document.querySelector('[data-add-to-cart]')||document.querySelector('.product-form__submit');
    if(btn){btn.click();return true;}
    if(f){f.requestSubmit?f.requestSubmit():f.submit();return true;}
  }catch(e){}
  return false;
}
function detectSizes(){
  try{
    var found=[],rows=chart().rows;
    document.querySelectorAll('[data-product-variants] label, .product__selectors label, .radio__button label').forEach(function(l){
      var t=(l.textContent||'').trim().toUpperCase();
      if(/^(XS|S|M|L|XL|XXL|XXXL)$/.test(t)&&found.indexOf(t)<0&&rows[t])found.push(t);
    });
    SIZES=found.length?found:Object.keys(rows);
  }catch(e){SIZES=Object.keys(chart().rows);}
}
function hostEl(force){
  var host=document.querySelector('.product__submit__item')||document.getElementById('add--cart-btn-pro')||document.querySelector('[data-add-to-cart]:not(.cart-bar__btn)')||document.querySelector('button[name="add"]');
  if(!host&&force)host=document.querySelector('.product__form__holder')||document.querySelector('[data-product-variants]')||document.querySelector('.product__selectors');
  return host;
}
var RULER='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 7h18v10H3z"/><path d="M7 7v4M11 7v6M15 7v4M19 7v6"/></svg>';
function renderMount(force){
  var host=hostEl(force);
  if(!host)return false;
  var old=document.querySelector('.qsq-open, .qsq-mysize-wrap');if(old)old.remove();
  var prof=load();
  var el;
  if(prof){
    /* profiel bestaat -> reken de maat voor DIT product en toon de pill */
    var snap=JSON.stringify(q);
    Object.assign(q,prof);if(!q.anchor)q.anchor={brand:'',size:''};q.est=estimate();
    var sz;try{sz=recommend().size;}catch(e){sz=null;}
    q=JSON.parse(snap);
    if(sz){
      el=document.createElement('div');el.className='qsq-mysize-wrap';
      el.innerHTML='<button type="button" class="qsq-mysize">'+RULER+' <span>'+T('yoursize')+' <b>'+sz+'</b></span><span class="qm-q" role="button" aria-label="Why this size">?</span></button>'+
        '<div class="qsq-tip" hidden><button class="tx" aria-label="Close">&times;</button><h5>'+T('tip_h')+'</h5><p>'+T('tip_p')+'</p></div>';
      var pill=el.querySelector('.qsq-mysize'),tip=el.querySelector('.qsq-tip'),qm=el.querySelector('.qm-q');
      pill.onclick=function(e){if(e.target===qm||qm.contains(e.target))return;open();};
      qm.onclick=function(e){e.stopPropagation();var show=tip.hidden;tip.hidden=!show;
        if(show){setTimeout(function(){document.addEventListener('click',outside);},0);}
        function outside(ev){if(!el.contains(ev.target)){tip.hidden=true;document.removeEventListener('click',outside);}}};
      tip.querySelector('.tx').onclick=function(e){e.stopPropagation();tip.hidden=true;};
    }
  }
  if(!el){
    el=document.createElement('button');el.type='button';el.className='qsq-open';
    el.innerHTML=RULER+' '+T('whatsize');
    el.onclick=open;
  }
  host.parentNode.insertBefore(el,host.nextSibling);
  if(!window.__QSQ_IMP){window.__QSQ_IMP=1;track('impression');}
  return true;
}
function init(){css();detectSizes();if(!renderMount()){var t=0,iv=setInterval(function(){detectSizes();if(renderMount(t>=8)||++t>20)clearInterval(iv);},350);}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.QSQ={open:open,forget:function(){forget();renderMount();}};
})();
